import React from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";
class CorporateComponent extends React.Component {
  render() {
    return (
      <div>
        <Navbar/>
        &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      <div className='py-4 my-3'>
      <iframe
          title="Example Iframe"
          width="100%"
          height="900"
        className='px-4'
          src="https://corporateonboarding.norrenberger.com/"
          frameBorder="0"
        />
      </div>
      
           <Footer/>
      </div>
    );
  }
}

export default CorporateComponent;
